module.exports = __webpack_public_path__ + "static/media/3.a3ff00c9.jpg";